<template>
  <b-button-group class="my-1" v-if="show">
    <b-button variant="primary"
              @click="toggleProduct">
      <b-icon-arrow-left-right aria-hidden="true"></b-icon-arrow-left-right>
    </b-button>
    <b-button v-for="p in productsPresent" :key="p"
              @click="switchProduct(p)"
              :pressed="product.key == p ? true: false"
              size="sm">
      {{ products[p].title }}
    </b-button>
  </b-button-group>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { BIconArrowLeftRight } from 'bootstrap-vue';

export default {
  name: 'ProductSwitcher',
  components: {
    BIconArrowLeftRight,
  },
  props: {
    // msg: String,
  },
  computed: {
    designPresent() {
      return !!this.design.image.key;
    },
    productsPresent() {
      return Object.keys(this.products);
    },
    currentProduct() {
      return this.product.key;
    },
    show() {
      return this.productsPresent.length > 1;
    },
    ...mapState(['product', 'products']),
    ...mapGetters(['design']),
  },
  methods: {
    switchProduct(productname) {
      const designname = productname;
      this.$store.commit('changeCurrentProduct', productname);
      this.$store.commit('changeCurrentDesign', designname);
      if (this.designPresent) {
        this.$emit('designLoaded');
      } else {
        console.log('loaded empty design');
      }
    },
    toggleProduct() {
      const productlist = this.productsPresent;
      const selectedIndex = productlist.indexOf(this.currentProduct);
      const newIndex = (selectedIndex + 1) % productlist.length;
      this.switchProduct(productlist[newIndex]);
    },
    // normalDesign() {
    //   console.log('switchDesign: cap');
    //   this.switchDesign('cap', 'design');
    // },
    // neckerDesign() {
    //   console.log('switchDesign: necker');
    //   // console.log(this.altProducts);
    //   this.switchDesign('necker', 'necker');
    // },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
